module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/347.1e3a063a.png";